import React from 'react'
import { Info } from 'lucide-react'
import styles from './InfoAlert.module.scss'

interface InfoAlertProps {
  children: React.ReactNode
}

export const InfoAlert: React.FC<InfoAlertProps> = ({ children }) => (
  <div className={styles.alert}>
    <Info size={16} />
    <span>{children}</span>
  </div>
)
